import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "UnifiedConsent" */ "./lazyIndex"), { name: "UnifiedConsent" });

export const lazyLaunchUnifiedConsentDialog: LazyAction<typeof lazyIndex.launchUnifiedConsent, typeof lazyModule> = new LazyAction(lazyModule, m => m.launchUnifiedConsent);
